// frontend/src/components/NoSectionAccess.tsx
//
// Экран «раздел недоступен» (GitLab #337).
//
// # Зачем
//
// Часть разделов при недостатке прав молча подменялась дашбордом: адрес
// оставался прежним, сообщения не было, объяснения тоже. Проверено на стенде
// под пользователем без единого назначения прав — `/admin/users-management`,
// `/jobs`, `/trash` открывали дашборд. Человек, перешедший по ссылке от
// коллеги, оказывался «не там» без единого слова почему, и это неотличимо от
// поломки приложения.
//
// # Почему не NoAccessMessage
//
// Тот экран построен вокруг заявки на доступ к КОНКРЕТНОМУ ресурсу: он
// принимает тип, идентификатор и название, и его кнопка открывает форму заявки
// по этому ресурсу. У раздела ресурса нет — заявку не на что подавать, права
// сюда даёт администратор целиком. Поэтому отдельный экран, а не натягивание
// существующего на чужой сценарий.

import React from 'react';
import { Button, Card, Result, Space } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

interface NoSectionAccessProps {
  /** Что именно требуется — показывается пользователю как причина. */
  requirement?: string;
}

const NoSectionAccess: React.FC<NoSectionAccessProps> = ({ requirement }) => {
  const { t } = useTranslation('pages');
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Card
      style={{ maxWidth: 600, margin: '40px auto' }}
      data-testid="no-section-access"
    >
      <Result
        icon={<LockOutlined style={{ color: '#faad14' }} />}
        title={t('noSectionAccess.title')}
        subTitle={requirement ?? t('noSectionAccess.subtitle')}
        extra={
          <Space direction="vertical" size={12} align="center">
            {/* Адрес показывается по той же причине, что и на странице 404
                (#320): чаще всего сюда приводит чужая ссылка, и первый вопрос
                человека — куда он попал. Выводится текстом, не разметкой. */}
            <span
              style={{ opacity: 0.65 }}
              data-testid="no-section-access-path"
            >
              {location.pathname}
            </span>
            <Space>
              <Button
                type="primary"
                data-testid="no-section-access-home"
                onClick={() => navigate('/dashboard')}
              >
                {t('noSectionAccess.goHome')}
              </Button>
              <Button
                data-testid="no-section-access-back"
                onClick={() => navigate(-1)}
              >
                {t('noSectionAccess.goBack')}
              </Button>
            </Space>
          </Space>
        }
      />
    </Card>
  );
};

export default NoSectionAccess;
